import { render, staticRenderFns } from "./debentureHolderInformation.vue?vue&type=template&id=1f7ca2b6&scoped=true"
import script from "./debentureHolderInformation.vue?vue&type=script&lang=js"
export * from "./debentureHolderInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7ca2b6",
  null
  
)

export default component.exports